export enum DatSelectionSteps {
    // In upper case so it can be converted from a text of the url
    NONE = "",
    SUMARRY = "summary",
    EXTERN = "extern",
    CALCULATION = "calculation",
    DETAILS = "details-page",
    DATSETTINGS = "dat-settings",
}
